<!-- Container que decide qué versión renderizar según el flujo -->
<app-sales-verification-code-v3
  *ngIf="isFlowKrdya"
  (nextStepEvent)="onNextStep()">
</app-sales-verification-code-v3>